import FieldRenderer from "./FieldRenderer";

export default function SignUpFormFields({ fields, errors, modalType, ...handlers }) {
  return (
    <>

      <div className="inner-content tw-mx-0 sm:tw-mx-[50px] tw-my-0">
        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-0 sm:tw-gap-x-4 sm:tw-gap-y-0 tw-px-0 --sm:tw-px-5 mx-auto">
          {fields.map((field) => (
            <FieldRenderer
              key={`${modalType}-${field.key}`}
              className="tw-w-full tw-mb-2 sm:tw-mb-0 tw-relative"
              field={field}
              errors={errors}
              modalType={modalType}
              withLabel={true} // để render label + required giống code cũ
              {...handlers} />
          ))}
        </div>
      </div>
    </>

  );
}
